import { Activity } from "../models";
import t from "../../translations/he";

// Function to get ALL activities for export (no pagination)
export async function getAllActivities(query) {
	let queryRef = Activity.orderBy("dateCreated", "desc");

	if (query?.status === "pending") {
		queryRef = queryRef.where("approved", "==", false);
	}

	if (query?.status === "approved") {
		queryRef = queryRef.where("approved", "==", true);
	}

	if (!!query?.region && query?.region !== t?.all) {
		queryRef = queryRef.where("user.region", "==", query?.region);
	}

	// No limit - fetches all matching activities
	return queryRef.get().then((s) =>
		s.docs.map((d) => ({ id: d.id, ...d.data() }))
	);
}

export default async function getActivities(query, lastResult) {
	let queryRef = Activity.orderBy("dateCreated", "desc");

	if (query?.status === "pending") {
		queryRef = queryRef.where("approved", "==", false);
	}

	if (query?.status === "approved") {
		queryRef = queryRef.where("approved", "==", true);
	}

	if (!!query?.region && query?.region !== t?.all) {
		queryRef = queryRef.where("user.region", "==", query?.region);
	}

	if (lastResult) {
		queryRef = queryRef.startAfter(lastResult);
	}

	return queryRef
		.limit(10)
		.get()
		.then((s) => ({
			lastResult: s.docs?.[s.docs.length - 1],
			data: s.docs.map((d) => ({ id: d.id, ...d.data() })),
		}));
}
